// ECharts renders to canvas and cannot resolve CSS var(), so chart colors and
// fonts are read from the live FDS tokens (src/style/fds-tokens.scss) at the
// moment the chart options are built.
export function fdsToken(name: string): string {
  return getComputedStyle(document.body).getPropertyValue(name).trim();
}

export function fdsFontFamily(): string {
  return `${fdsToken("--fds-typography-fontFamily-primary")}, sans-serif`;
}
